export default __webpack_public_path__ + "static/media/Scarclaw Helm.e1ea36f8.jpg";